const environments = {
  VITE_APP_STRIPE_API_KEY: import.meta.env.VITE_APP_STRIPE_API_KEY,
};

type EnvsKeys = keyof typeof environments;

function getEnvVariable(key: EnvsKeys) {
  const variable = environments[key];

  if (!variable) {
    throw new Error(`${key} .env variable is missing.`);
  }

  return variable;
}

export {environments, getEnvVariable};
